import { useCallback, useEffect, useRef } from 'react';

export const useDialog = (isOpen: boolean, onClose: () => void) => {
	const dialogRef = useRef<HTMLDialogElement>(null);

	useEffect(() => {
		const dialog = dialogRef.current;
		if (!dialog) return;

		if (isOpen) {
			if (!dialog.open) dialog.showModal();
			document.body.style.overflow = 'hidden';
		} else {
			if (dialog.open) dialog.close();
			document.body.style.overflow = '';
		}
		return () => {
			document.body.style.overflow = '';
		};
	}, [isOpen]);
	const handleBackdropClick = useCallback(
		(e: React.MouseEvent<HTMLDialogElement>) => {
			const dialog = dialogRef.current;
			if (!dialog) return;

			const rect = dialog.getBoundingClientRect();
			const isInDialog = e.clientX >= rect.left && e.clientX <= rect.right && e.clientY >= rect.top && e.clientY <= rect.bottom;

			if (!isInDialog) {
				onClose();
			}
		},
		[onClose]
	);

	return {
		dialogRef,
		handleBackdropClick
	};
};
